import { GET_THEME, SET_THEME } from '../types/General/themeActionTypes'

export const setTheme = (theme) => {
    return {
        type: SET_THEME,
        payload: theme
    };
}

export const getTheme = _ => {
    return {
        type: GET_THEME
    };
}
